<div class="TitleFormAlert">
  <span class="title">{{ title | translate }}</span>
  <span class="text-am-white-transp75 fs-24px lh-32px fw-medium-x text-400" *ngIf="subtitle !=''">{{ subtitle | translate }}</span>
  <div *ngIf="showIcon">
    <img alt="" src="../../../../assets/images/formCorrect.svg" class="TitleFormAlert-icon" *ngIf="valid" />
    <img alt="" src="../../../../assets/images/formIncorrect.svg" class="TitleFormAlert-icon" *ngIf="!valid" />
  </div>
</div>
